const $ = jQuery;
import owlCarousel from "owl.carousel";

// import 'owl.carousel';

export {
    $,
    owlCarousel,
}